<template>
  <hypto-popup :title="`${upiOptions.status} UPI ID`">
    <template v-slot:body>
      <p>Are you sure you want to {{upiOptions.status}} UPI ID <b>'{{upiOptions.upi}}'</b>?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="toggleStatus">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

export default {
  name: 'ToggleUpiStatus',
  components: { HyptoPopup },
  props: {
    upiOptions: Object
  },
  methods: {
    toggleStatus () {
      this.$emit('toggleStatusAction')
    }
  }
}
</script>
